import Model from 'models/Model';
import IProduct from 'models/productManagement/product/Model.Product';
import postingAccountDeleteApi from './delete/Api.PostingAccount.Delete';
import postingAccountListApi from './list/Api.PostingAccount.List';
import postingAccountSaveApi from './save/Api.PostingAccount.Save';

export default class PostingAccount
  extends Model<Model.IPostingAccount>({ icon: 'if-login' })
  implements Model.Instance<Model.IPostingAccount>
{
  id: number;
  ledgerAccountName: string;
  currency: Model.Enum.Currency;
  isActive: boolean;
  isPayable: boolean;
  isReceivable: boolean;
  products?: IProduct[];

  constructor(
    data: Partial<Model.IPostingAccount> | Utils.FormData<Model.IPostingAccount>,
    language?: Locale.Languages
  ) {
    super({ products: [IProduct] }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.ledgerAccountName || this.id.toString(),
      subtitle: this.currency,
    };
  }
  static async list(body?: Api.Core.PostingAccount.List.IRequest) {
    const { payload, ...rest } = await postingAccountListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new PostingAccount(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await postingAccountSaveApi(this);
  }
  async delete() {
    return await postingAccountDeleteApi(this.id);
  }
}
